var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateLastBillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.505 3.203c-.992 0-1.785.805-1.785 1.785v1.069h3.57V4.988c0-.98-.794-1.785-1.785-1.785z",
    fill: "url(#uevh192iza)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m14.502 21.458-.22-.22-.004-.004-.783-.76-.353-.344-.349.349-.57.57-.003.003-.393.387-.222-.222-.002-.003-.76-.749-.354-.348-.351.35-.57.57-.003.004-.371.365-.222-.222-.006-.006-.683-.661-.353-.342-.348.348-.57.57-.003.003-.25.244-.222-.222-.006-.006-.683-.661-.353-.342-.348.348-.447.446V5.61c.02-1.074.858-1.907 1.814-1.907h9.373a2.325 2.325 0 0 0-.386 1.285V20.46l-.063.063-.573.573-.363.362z",
    fill: "url(#xa8xfsvnwb)",
    stroke: "url(#z33l9ozghc)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M4.722 5.605c0-.837.547-1.55 1.295-1.804a2.887 2.887 0 0 0-.632 1.804v14.706l-.155.15-.508.49V5.605z",
    fill: "url(#k8sy18ok7d)",
    stroke: "url(#w1q3y6zube)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66 7.115h1.608M7.659 9.89h6.545m-6.545 2.766h6.545m-6.545 2.776h6.545m-1.961 2.17h1.961m5.3-14.4H6.624a2.408 2.408 0 0 0-2.402 2.402V22.1l1.355-1.278 1.3 1.234 1.234-1.168 1.3 1.234 1.355-1.278 1.389 1.311 1.377-1.3 1.41 1.322 1.355-1.278 1.41 1.333V4.988a1.784 1.784 0 1 1 3.57 0v1.069h-3.58",
    stroke: "url(#45qbjz6ttf)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uevh192iza",
    x1: 20.369,
    y1: 7.586,
    x2: 16.984,
    y2: 5.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xa8xfsvnwb",
    x1: 14.232,
    y1: 32.324,
    x2: -0.513,
    y2: 28.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z33l9ozghc",
    x1: 14.232,
    y1: 32.324,
    x2: -0.513,
    y2: 28.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k8sy18ok7d",
    x1: 7.238,
    y1: 32.239,
    x2: 2.492,
    y2: 31.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w1q3y6zube",
    x1: 7.238,
    y1: 32.239,
    x2: 2.492,
    y2: 31.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "45qbjz6ttf",
    x1: 16.878,
    y1: 32.425,
    x2: -0.975,
    y2: 26.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateLastBillIcon);
export default __webpack_public_path__ + "static/media/corporateLastBillIcon.7653903e6b1f66589d802d0484bfb35c.svg";
export { ForwardRef as ReactComponent };